import german from "@/assets/languages/german/index";

export const messages = {
    de: german
}